
const fields = {
  family_name: {
    required: true,
    message: "姓を入力してください。",
    rules: [
      {
        name: "length",
        value: 100,
        message: "姓は100文字以内で入力してください。"
      }
    ]
  },
  given_name: {
    required: true,
    message: "名を入力してください。",
    rules: [
      {
        name: "length",
        value: 100,
        message: "名は100文字以内で入力してください。"
      }
    ]
  },
  phone: {
    required: true,
    message: "電話番号を入力してください。",
    rules: [
      {
        name: "pattern",
        value: /^[\d\-\(\)]+$/,
        message: "正しい電話番号を入力してください。"
      },
      {
        name: "length",
        value: 16,
        message: "電話番号は16文字以内で入力してください。"
      }
    ]
  },
  email: {
    required: true,
    message: "メールアドレスを入力してください。",
    rules: [
      {
        name: "length",
        value: 100,
        message: "メールアドレスは100文字以内で入力してください。"
      },
      {
        name: "email",
        value: true,
        message: "正しいメールアドレスを入力してください。"
      }
    ]
  },
  email_confirm: {
    required: true,
    message: "メールアドレスを再度入力してください。",
    rules: [
      {
        name: "equal",
        value: "email",
        message: "メールアドレスが一致しません。"
      }
    ]
  },
  category: {
    required: true,
    message: "お問い合わせ種別を選択してください。"
  },
  message: {
    required: true,
    message: "お問い合わせ内容を入力してください。",
    rules: [
      {
        name: "length",
        value: 1000,
        message: "お問い合わせ内容は1000文字以内で入力してください。"
      }
    ]
  }
};

export default fields;



// WEBPACK FOOTER //
// ./src/data/contact-form-fields.js